import {Cookies} from "react-cookie";
import { AxiosRequestConfig } from 'axios';
import { COOKIE_KEY } from "../constants/cookie";
import {LANG_KEY} from "../constants";

const cookies = new Cookies()

export const configNew = (): AxiosRequestConfig => {
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  // let lang = cookies.get(COOKIE_KEY.LANG) || LANG_KEY.RU
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang') || LANG_KEY.RU; 
  const isEmbed = urlParams.get('embed'); 
  const eToken = urlParams.get('etoken'); 

  const langMap: Record<string, string> = {
    kk: "kk-KZ",
    ru: "ru-RU",
    en: "en-EN",
    ar: "ar-AR",
  };
  return {
    baseURL: `${process.env.REACT_APP_URL}`,
    headers: {
      'accept': 'application/json, text/plain, */*',
      'Access-Control-Allow-Origin': '*',
      'Accept-Language': langMap[lang],
      // 'Accept-Language': lang === "kk" ? "kk-KZ" : "ru-RU",
      // 'Content-Type': "application/json; charset=UTF-8",
      ...(token ? {'Authorization': `Bearer ${token}`} : {}),
      ...(isEmbed ? {'Embed': `${isEmbed}`} : {}),
      ...(eToken ? {'Etoken': `${eToken}`} : {}),
    }
  }
}